import React from "react";
import { ArrowRight } from "lucide-react";
import { useContactModal } from "../context/ContactModalContext";

export default function About() {
  const { openContactModal } = useContactModal() || {};
  const bullets = [
    "REPEXO MEDICAL ist ein inhabergeführtes Unternehmen mit Fokus auf höchste Qualität und strukturierte Prozesse.",
    "Wir haben Zugang zu den wichtigsten internationalen Märkten und wachsen seit Jahren kontinuierlich.",
    "Unsere Mitarbeiter erhalten spannende Herausforderungen sowie Möglichkeiten zur kontinuierlichen Weiterentwicklung.",
    "Wir fördern eine gesunde Balance zwischen ambitionierter Karriere und Familienleben.",
    "Durch unsere Mitgliedschaft im Netzwerk „Erfolgsfaktor Familie“ unterstützen wir unsere Mitarbeiter aktiv.",
    "Unsere Mitarbeiter bauen langfristige und starke Beziehungen zu Kunden und Kandidaten auf.",
    "REPEXO Medical ist spezialisiert auf Personalrekrutierung im Healthcare-Bereich durch Direktansprache (Headhunting).",
    "Zusätzlich unterstützen wir die Nachfolgeregelung für medizinische Praxen und Institute.",
    "Wir besetzen medizinische Positionen wie Fachärzte, Medizintechniker, Pharma-Spezialisten, wissenschaftliche Mitarbeiter und medizinische Führungskräfte.",
    "Wir arbeiten sowohl für mittelständische Unternehmen als auch für internationale Global Player im Healthcare-Markt.",
    "Unsere Berater und Expertenteams verfügen über nationale und internationale Branchenerfahrung.",
    "Unser Kerngeschäft ist die diskrete Direktansprache von qualifizierten Führungskräften und Spezialisten.",
    "Wir identifizieren, kontaktieren und motivieren passende Kandidaten für unsere Mandanten.",
    "Je nach Position bieten wir unseren Kunden flexible und schnelle Rekrutierungszeiträume.",
  ];

  const firstColumn = bullets.slice(0, Math.ceil(bullets.length / 2));
  const secondColumn = bullets.slice(Math.ceil(bullets.length / 2));

  return (
    <section className="bg-white py-10">
      <div className="mx-auto container-app">
        <div className="max-w-[980px]">

          {/* Heading */}
          <h2 className="text-xl sm:text-3xl md:text-4xl font-semibold md:font-medium text-gray-900">
            Warum REPEXO MEDICAL?
            <br />
            Was macht uns besonders?
          </h2>

          {/* Intro */}
          <p className="mt-6 text-[14px] leading-6 text-neutral-900/80">
            REPEXO Medical ist eine spezialisierte Personalberatung im
            Healthcare-Bereich mit Fokus auf Direktansprache (Headhunting).
            Unsere strukturierte Arbeitsweise, internationale Marktzugänge und
            erfahrenen Berater ermöglichen es uns, Unternehmen erfolgreich bei
            der Besetzung anspruchsvoller Positionen zu unterstützen.
          </p>

          {/* Bullet grid */}
          <div className="mt-10 grid grid-cols-1 gap-x-14 gap-y-6 md:grid-cols-2">

            {/* Left column */}
            <ul className="space-y-6 text-[14px] leading-6 text-neutral-900/85">
              {firstColumn.map((item, index) => (
                <li key={index} className="flex gap-3">
                  <span className="mt-[9px] h-[5px] w-[5px] flex-none rounded-full bg-neutral-900/70" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            {/* Right column */}
            <ul className="space-y-6 text-[14px] leading-6 text-neutral-900/85">
              {secondColumn.map((item, index) => (
                <li key={index} className="flex gap-3">
                  <span className="mt-[9px] h-[5px] w-[5px] flex-none rounded-full bg-neutral-900/70" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>

          </div>

          {/* Contact CTA */}
          <div className="mt-12 flex justify-start">
            <button
              type="button"
              onClick={() => openContactModal?.()}
              className="group btn btn-bg text-gray-900"
            >
              Jetzt Kontakt aufnehmen
              <ArrowRight className="h-5 w-6 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-0.5" aria-hidden />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}